import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { User } from '../../_models/user';
import { Subject } from 'rxjs';
import { Register } from '../../_models/register';
import { Caller } from '../../_models/caller';
import { OrderMenu } from '../../_models/orderMenu';
import { AlertService } from '../../_services/alert.service';
import { AccessSecurity } from '../../_models/accessSecurity';
import { saveAs } from 'file-saver';
import { ExcelServiceService } from '../../_models/excel-service.service';

@Component({
  selector: 'app-admin-products',
  templateUrl: './admin-products.component.html',
  styleUrls: ['./admin-products.component.css']
})
export class AdminProductsComponent implements OnInit {
  inventoriesMainMenu: OrderMenu[] = [
    { displayName: "All", tabClicked: "all", orderStatus: "ALL", additional: "N" },
    { displayName: "Active", tabClicked: "active", orderStatus: "ACTIVE", additional: "N" },
    { displayName: "Inactive", tabClicked: "inactive", orderStatus: "IN_ACTIVE", additional: "N" },
  ];
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  tabClicked: string;
  printOptionType: string;
  status: string;
  require: any;
  statusText1: string = "";
  statusText2: string = "";
  uploadDismissModal: string = "";
  uploadPopup: string = "";
  accountOwnerId: string;
  productType: string;
  products: any;
  accountOwners: any;
  onHandQuantityRecords: any;
  productImage: string = "";
  errorMessage: string;
  checkedList: any;
  loading = true;
  totalCount: any;
  barCodePopUP2: string = 'N';
  c: any;
  productsList: any;
  selectImport: string = "PRODUCTS";
  masterSelected: boolean = false;
  productStatus: any = 'ALL';
  totalRecords: number;
  previousStatus = '';
  displayPopUP: string = 'N';
  barCodePopUP: string = 'N';
  enterQuantity = [];
  quantity: number = 1;
  quantityError: string;
  checkedListView = [];
  barcodeValue: string = "";
  qrCodeValue: string = "";
  selectedProductID: number;
  selectedProductName: string;
  selectedProductSKU: string;
  printTypes: string;
  printOptionError: string;
  userDrop2: any = 'ALL';
  toDayDateAndTime = new Date().toLocaleString();

  constructor(private alertService: AlertService, private excelService: ExcelServiceService, private http: HttpClient, private router: Router, private api: ApiIntegration, private g: Globals, public user: User, public register: Register, public caller: Caller, public accessSec: AccessSecurity) {
    //this.user.value="ALL";
    this.g.page = "Products";
    this.tabClicked = this.g.pageTab;
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      for (let ol of this.inventoriesMainMenu) {
        if (ol.tabClicked === this.g.pageTab) {
          this.populateTabData(this.g.pageTab, ol.orderStatus);
          this.switchPosition(ol);
        }
      }
    } else {
      this.tabClicked = "all";
      this.populateTabData('all', "ALL");
    }
  }

  populate(orderChange) {
    this.api.getProductsByStatusAdmin("1", orderChange).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.productsList = data.productsList;
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }

  tabChange() {
    this.checkedList = [];
    this.errorMessage = "";
    this.g.loaderDisplay = "display";
  }

  quantityBlur() {
    this.quantityError = "";
    if (this.quantity === null || this.quantity === undefined || this.quantity <= 0) {
      this.quantityError = 'Please enter quantity as minimum 1';
    }
    if (this.quantityError != "") {
      return false;
    }
  }

  openBarcodePopup() {
    this.quantityError = "";
    this.printOptionError = "";
    if (this.quantity === null || this.quantity === undefined || this.quantity <= 0) {
      this.quantityError = 'Please enter quantity as minimum 1';
    }
    if (this.printTypes === null || this.printTypes === undefined || this.printTypes === '' || this.printTypes === 'undefined') {
      this.printOptionError = 'Please Select PrintOption';
    }
    if (this.quantityError != "" || this.printOptionError != "") {
      return false;
    }
    for (var i = 0; i < this.checkedList.length; i++) {
      this.barcodeValue = 'PROD' + this.checkedList[i];
    }
    this.enterQuantity = [];
    for (let q = 0; q < this.quantity; q++) {
      this.enterQuantity.push(q);
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/pdf');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.g.loaderDisplay = "display";
    this.http.post(environment.apiUrl + 'api/getPdfUrl', {
      "labelSize": this.printTypes.split(' ')[0],
      "productId": this.checkedList[0],
      "printType": "BARCODE",
      "noOfLabels": this.quantity
    },
      { responseType: 'blob', headers: header1 }).subscribe((resp: any) => {
        console.log(resp);
        var mediaType = 'application/pdf';
        var blob = new Blob([resp], { type: mediaType });
        var filename = 'barCode.pdf';
        saveAs(blob, filename);
        this.g.loaderDisplay = "";
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
  }

  openQRCodePopup() {
    this.quantityError = "";
    this.printOptionError = "";

    if (this.quantity === null || this.quantity === undefined || this.quantity <= 0) {
      this.quantityError = 'Please enter quantity as minimum 1';
    }
    if (this.printTypes === null || this.printTypes === undefined || this.printTypes === '' || this.printTypes === 'undefined') {
      this.printOptionError = 'Please Select PrintOption';
    }
    if (this.quantityError != "" || this.printOptionError != "") {
      return false;
    }

    for (var i = 0; i < this.checkedList.length; i++) {
      this.qrCodeValue = 'PROD-' + this.checkedList[i];
    }
    this.enterQuantity = [];
    for (let q = 0; q < this.quantity; q++) {
      this.enterQuantity.push(q);
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/pdf');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.g.loaderDisplay = "display";
    this.http.post(environment.apiUrl + 'api/getPdfUrl', {
      "labelSize": this.printTypes.split(' ')[0],
      "productId": this.checkedList[0],
      "printType": "QRCODE",
      "noOfLabels": this.quantity
    }, { responseType: 'blob', headers: header1 })
      .subscribe((resp: any) => {
        console.log(resp);
        var mediaType = 'application/pdf';
        var blob = new Blob([resp], { type: mediaType });
        var filename = 'qrCode.pdf';
        saveAs(blob, filename);
        this.g.loaderDisplay = "";
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
  }


  qRCodeAndBarCodePopup() {
    console.log('sfsd:' + this.checkedListView);
    this.quantityError = "";
    this.printOptionError = "";

    if (this.quantity === null || this.quantity === undefined || this.quantity <= 0) {
      this.quantityError = 'Please enter quantity as minimum 1';
    }
    if (this.printTypes === null || this.printTypes === undefined || this.printTypes === '' || this.printTypes === 'undefined') {
      this.printOptionError = 'Please Select PrintOption';
    }
    if (this.quantityError != "" || this.printOptionError != "") {
      return false;
    }

    for (var i = 0; i < this.checkedList.length; i++) {
      this.qrCodeValue = 'PROD-' + this.checkedList[i];
    }
    this.enterQuantity = [];
    for (let q = 0; q < this.quantity; q++) {
      this.enterQuantity.push(q);
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/pdf');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.g.loaderDisplay = "display";
    this.http.post(environment.apiUrl + 'api/getPdfUrl', {
      "labelSize": this.printTypes.split(' ')[0],
      "productId": this.checkedList[0],
      "printType": "BOTH",
      "noOfLabels": this.quantity
    }, { responseType: 'blob', headers: header1 }).subscribe((resp: any) => {
      console.log(resp);
      var mediaType = 'application/pdf';
      var blob = new Blob([resp], { type: mediaType });
      var filename = 'prod_' + this.selectedProductName + '_label_' + this.toDayDateAndTime + '.pdf';
      saveAs(blob, filename);
      this.displayPopUP = 'N';
      this.g.loaderDisplay = "";
    },
      (err) => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
  }


  printPopUp(p, printType) {
    this.displayPopUP = 'Y';
    this.printOptionType = printType;
  }

  closePopUp() {
    this.displayPopUP = 'N';
    this.quantity = 1;
  }

  closePopUpBarCode() {
    this.barCodePopUP = 'N';
  }

  clear() {
    this.displayPopUP = 'N';
    this.quantity = 1;
  }

  print() {
    window.print();
  }


  switchPosition(om) {
    let index = this.inventoriesMainMenu.indexOf(om);
    om.additional = 'N';
    if (om.displayName !== this.inventoriesMainMenu[5].displayName) {
      this.inventoriesMainMenu[5].additional = 'Y';
    }
    var tmp = 4;
    for (let o of this.inventoriesMainMenu) {
      if (tmp < this.inventoriesMainMenu.length) {
        if (om.displayName !== this.inventoriesMainMenu[tmp].displayName) {
          this.inventoriesMainMenu[tmp].additional = 'Y';
        }
        tmp = tmp + 1;
      }
    }
  }

  selectedOnHandQuantity(records) {
    this.onHandQuantityRecords = records;
  }

  getProductsByStatus(status) {
    this.dtOptions = {
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      language: {
        searchPlaceholder: 'Search by Product Name / SKU / Store SKU / HSN Code'
      },
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.productStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.productStatus;
        }
        let query: any = {
          status: this.productStatus,
          organizationId: 1,
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        let apiMethod = 'api/getProductsByStatusAndOrgIdAndAOId';
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        this.g.loaderDisplay = "display";
        this.http.get(environment.apiUrl + apiMethod, { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.g.loaderDisplay = "";
            this.productsList = resp.productsList;
            this.totalRecords = resp.noOfProducts;
            this.productsList.forEach((s) => {
              s['isSelected'] = false;
            });
            callback({
              recordsTotal: resp.noOfProducts,
              recordsFiltered: resp.noOfProducts
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    };
  }

  exportToXLSX() {
    this.excelService.exportAsExcelFile(this.productsList, 'sample');
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {

    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }

  populateTabData(triggered, productStatus) {
    this.tabClicked = triggered;
    this.productStatus = productStatus;
    if (!this.previousStatus) {
      this.getProductsByStatus(productStatus);
    } else {
      this.rerender();
    }

  }

  changeStatus(p, index) {
    this.g.loaderDisplay = "display";
    if (p.status == "ACTIVE") {
      p.status = "IN_ACTIVE";
      this.rerender();
    } else {
      p.status = "ACTIVE";
      this.rerender();
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/changeProductStatus', {
      "accountOwnerId": p.accountOwnerId,
      "productId": p.productId,
      "organizationId": 1,
      "status": p.status
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.productsList.splice(index, 1);
          this.alertService.success('Product', 'Status Updated Successfully');
        } else {
          if (p.status == "ACTIVE") {
            p.status = "IN_ACTIVE";
          } else {
            p.status = "ACTIVE";
          }
          this.alertService.error(data['message']);
        }

        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";

        });

    if (this.tabClicked != 'all') {

      let index = this.productsList.indexOf(p);
      this.productsList.splice(index, 1);
    }
  }

  loadorder(event) {
    this.statusText2 = "";
    this.productImage = event.target.files[0];
  }


  submitImportProduct() {
    this.uploadDismissModal = "modal";
    this.uploadPopup = "#myModalOne";
    const file = this.productImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadFileToSaveProducts', formData, { headers: headerObj }).subscribe(data => {
      if (data['code'] == 200) {
        this.alertService.success('Product', 'Submitted Successfully');

        // this.getProductsByStatus("ACTIVE");
        this.rerender();
      } else if (data['code'] == 400) {
        this.alertService.error('Error', data['message']);
        this.uploadDismissModal = "";
        this.uploadPopup = "#";
        return false;
      }
    },
      (err: HttpErrorResponse) => {
        this.uploadDismissModal = "";
        this.uploadPopup = "#";
      });
  }


  submitImportComponent() {
    this.uploadDismissModal = "modal";
    this.uploadPopup = "#myModalOne";
    const file = this.productImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadFileToSaveComponents', formData, { headers: headerObj }).subscribe(data => {
      if (data['code'] == 200) {
        this.alertService.success('Import Product', 'Submitted Successfully');
        this.rerender();
      } else if (data['code'] == 400) {
        this.alertService.error('Error', data['message']);
        this.uploadDismissModal = "";
        this.uploadPopup = "#";
        return false;
      }
    },
      (err: HttpErrorResponse) => {
        this.uploadDismissModal = "";
        this.uploadPopup = "#";
      });
  }

  submitAdmin() {
    this.caller.parent = "INVENTORY"
    this.router.navigate(['/admin/createInventory']);
  }

  selectShip(sl) {
    if (!sl.isSelected) {
      this.masterSelected = false
    }
    this.getCheckedShipList();
  }

  checkUncheckAll() {
    for (var i = 0; i < this.productsList.length; i++) {
      this.productsList[i].isSelected = this.masterSelected;
    }
    this.getCheckedShipList();
  }

  closePopUpBarCode2() {
    this.barCodePopUP2 = 'N';
  }

  getCheckedShipList() {
    this.checkedList = [];
    this.checkedListView = [];
    for (var i = 0; i < this.productsList.length; i++) {
      if (this.productsList[i].isSelected) {
        this.checkedList.push(this.productsList[i]['productId']);
        this.checkedListView.push(this.productsList[i]);
        this.selectedProductID = this.productsList[i]['productId'];
        this.selectedProductName = this.productsList[i]['productName'];
        this.selectedProductSKU = this.productsList[i]['sku'];
      }
    }
  }

  resetCheckedList() {
    this.checkedList = [];
    this.errorMessage = '';
  }

  editProduct(products) {
    let i = 0;
    let ohid;
    for (let j of products) {
      if (j.isSelected) {
        i = i + 1;
        ohid = j.productId;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/editInventory/' + ohid]);
    } else {
      this.errorMessage = "Can not edit multiple products at once. Please select one at a time";
    }
  }

  reset() {
    this.selectImport = "PRODUCTS";
    this.removeFile();
  }

  removeFile() {
    this.productImage = "";
  }

  getFileName(fileupload): string {
    var filename = fileupload.replace(/^.*[\\\/]/, "");
    return filename;
  }
}
